export { CertificationCertificateView } from './CertificationCertificateView';